import { render, staticRenderFns } from "./Chem1LD_LFQ_Question6.vue?vue&type=template&id=e8319892&scoped=true&"
import script from "./Chem1LD_LFQ_Question6.vue?vue&type=script&lang=js&"
export * from "./Chem1LD_LFQ_Question6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8319892",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSelect,VSimpleTable})
